import { IContactRelation, IGender } from "../graphql";
export const LegalForm = [
    "GmbH",
    "Unternehmergesellschaft (haftungsbeschränkt)",
    "GmbH & Co. KG",
    "Einzelunternehmen",
    "Freiberufler",
    "GbR",
    "OHG",
    "KG",
    "AG",
    "KGaA",
    "Verein",
    "Genossenschaft",
    "Partnerschaftsgesellschaft",
    "Sonstige Gesellschaft",
];
export const GenderTranslate = {
    [IGender.Female]: "Frau",
    [IGender.Male]: "Herr",
    [IGender.Div]: "",
};
export { RegisterEnum };
var RegisterEnum;
(function (RegisterEnum) {
    RegisterEnum["HRA"] = "HRA";
    RegisterEnum["HRB"] = "HRB";
    RegisterEnum["GnR"] = "GnR";
    RegisterEnum["PR"] = "PR";
    RegisterEnum["VR"] = "VR";
})(RegisterEnum || (RegisterEnum = {}));
export const RegisterList = {
    [RegisterEnum.HRA]: "Handelsregister Abteilung A",
    [RegisterEnum.HRB]: "Handelsregister Abteilung B",
    [RegisterEnum.GnR]: "Genossenschaftsregister",
    [RegisterEnum.PR]: "Partnerschaftsregister",
    [RegisterEnum.VR]: "Vereinsregister",
};
export const CountriesEuVatRules = {
    BE: { lengthRules: [10], symbols: "numeric" },
    BG: { lengthRules: [9, 10], symbols: "numeric" },
    DK: { lengthRules: [8], symbols: "numeric" },
    DE: { lengthRules: [9], symbols: "numeric" },
    EE: { lengthRules: [9], symbols: "numeric" },
    FI: { lengthRules: [8], symbols: "numeric" },
    FR: { lengthRules: [11], symbols: "alphanumeric" },
    EL: { lengthRules: [9], symbols: "numeric" },
    IE: { lengthRules: [8, 9], symbols: "alphanumeric" },
    IT: { lengthRules: [11], symbols: "numeric" },
    HR: { lengthRules: [11], symbols: "numeric" },
    LV: { lengthRules: [11], symbols: "numeric" },
    LT: { lengthRules: [9, 12], symbols: "numeric" },
    LU: { lengthRules: [8], symbols: "numeric" },
    MT: { lengthRules: [8], symbols: "numeric" },
    NL: { lengthRules: [12], symbols: "alphanumeric_special", specialChars: ["+", "*"] },
    XI: { lengthRules: [9, 12], symbols: "numeric" },
    AT: { lengthRules: [9], symbols: "alphanumeric" },
    PL: { lengthRules: [10], symbols: "numeric" },
    PT: { lengthRules: [9], symbols: "numeric" },
    RO: { lengthRules: { min: 2, max: 10 }, symbols: "numeric" },
    SE: { lengthRules: [12], symbols: "numeric" },
    SK: { lengthRules: [10], symbols: "numeric" },
    SI: { lengthRules: [8], symbols: "numeric" },
    ES: { lengthRules: [9], symbols: "alphanumeric" },
    CZ: { lengthRules: { min: 8, max: 10 }, symbols: "numeric" },
    HU: { lengthRules: [8], symbols: "numeric" },
    CY: { lengthRules: [9], symbols: "alphanumeric" },
};
export const isVatLengthValid = (countryCode, input) => {
    const requirements = CountriesEuVatRules[countryCode];
    if (!requirements) {
        return false;
    }
    const { lengthRules } = requirements;
    if (Array.isArray(lengthRules)) {
        return lengthRules.includes(input.length);
    }
    else if (lengthRules && typeof lengthRules === "object") {
        const { min, max } = lengthRules;
        return input.length >= min && input.length <= max;
    }
    return false;
};
export const getVatLengthMax = (countryCode) => {
    const requirements = CountriesEuVatRules[countryCode];
    if (!requirements) {
        return 10;
    }
    const { lengthRules } = requirements;
    if (Array.isArray(lengthRules)) {
        return Math.max(...lengthRules);
    }
    else if (lengthRules && typeof lengthRules === "object") {
        const { max } = lengthRules;
        return max;
    }
    return 10;
};
export { PaymentTermTypes };
var PaymentTermTypes;
(function (PaymentTermTypes) {
    PaymentTermTypes["\u00DCberweisung"] = "\u00DCberweisung";
    PaymentTermTypes["Lastschrift"] = "Lastschrift";
    PaymentTermTypes["Barzahlung"] = "Barzahlung";
    PaymentTermTypes["Sonstiges"] = "Sonstiges";
})(PaymentTermTypes || (PaymentTermTypes = {}));
export const relationTypeKontoOrder = Object.freeze([
    IContactRelation.Client,
    IContactRelation.Partner,
    IContactRelation.Employee,
    IContactRelation.Shareholder,
    IContactRelation.Other,
]);
//# sourceMappingURL=constants.js.map